<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner">
      <v-card class="auth-card">
        <!-- logo -->
        <v-card-title class="d-flex align-center justify-center py-7">
          <router-link to="/" class="d-flex align-center">
            <h2 class="text-2xl font-weight-semibold">{{ $t('general.name') }}</h2>
          </router-link>
        </v-card-title>

        <!-- login form -->
        <v-card-text>
          <v-form>
            <v-text-field
              v-model="email"
              outlined
              label="Email"
              hide-details="auto"
              class="mb-3"
              :rules="[value => !!value || 'Required.']"
            ></v-text-field>

            <v-text-field
              v-model="password"
              outlined
              :type="isPasswordVisible ? 'text' : 'password'"
              label="Password"
              :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
              hide-details="auto"
              @click:append="isPasswordVisible = !isPasswordVisible"
              :rules="[value => !!value || 'Required.']"
            ></v-text-field>

            <div id="error" class="d-flex align-center justify-end flex-wrap mt-2">Login Unsuccessful</div>

            <v-btn block color="primary" class="mt-6" @click="Login"> {{ $t('general.login') }} </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiFacebook, mdiTwitter, mdiGithub, mdiGoogle, mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
// import { ref } from '@vue/composition-api'
import { mapGetters, mapActions } from 'vuex'
//import { getData, postData } from '@/api'
import { globalFunc } from '@/global'
export default {
  name: 'Login',
  mixins: [globalFunc],
  data: () => ({
    isPasswordVisible: false,
    email: '',
    password: '',
    socialLink: [
      {
        icon: mdiFacebook,
        color: '#4267b2',
        colorInDark: '#4267b2',
      },
      {
        icon: mdiTwitter,
        color: '#1da1f2',
        colorInDark: '#1da1f2',
      },
      {
        icon: mdiGithub,
        color: '#272727',
        colorInDark: '#fff',
      },
      {
        icon: mdiGoogle,
        color: '#db4437',
        colorInDark: '#db4437',
      },
    ],
    icons: {
      mdiEyeOutline,
      mdiEyeOffOutline,
    },
  }),
  methods: {
    ...mapActions(['getData']),
    async Login() {
      if (this.email == '' || this.password == '') {
        return
      }

      try {
        //await commit('setUser', User.get('username'))
        let params = new URLSearchParams()
        params.set(
          'cms_login',
          JSON.stringify({
            user: this.email,
            password: this.password,
          }),
        )
        //let result = await getData(params)
        let send_data = []
        send_data['params'] = params
        send_data['method'] = 'getLoginData'
        this.getData(send_data)
      } catch (error) {
        globalFunc.log(error)
      }
    },
  },
  mounted() {
    document.getElementById('error').classList.add('hide')
    document.getElementById('error').classList.remove('d-flex')
  },
  computed: mapGetters(['login_status', 'login_data']),
  watch: {
    login_data: function(newVal, oldval) {
      if (newVal == '') {
        document.getElementById('error').classList.remove('hide')
        document.getElementById('error').classList.add('d-flex')
      } else {
        document.getElementById('error').classList.add('hide')
        document.getElementById('error').classList.remove('d-flex')
        this.$router.push({ name: 'Home' })
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/pages/auth.scss';

.hide {
  display: none !important;
}
</style>
